import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const PaymentSuccessful = ({ isPaymentSuccessful }) => {
  return (
    <SlidePanel isOpen={isPaymentSuccessful} onClose={() => {}}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        <div className="absolute top-0 right-0 h-[40px] w-[40px] opacity-0">
          <X />
        </div>
        <div className="flex items-center justify-center h-full">
          <div className="flex items-center justify-center min-h-[40%] w-full">
            <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-md mx-auto">
              <div className="flex items-center justify-center mt-10">
                <svg
                  width="53"
                  height="53"
                  viewBox="0 0 53 53"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="53" height="53" rx="26.5" fill="#7FB8EB" />
                  <path
                    d="M11 32L20.7544 38.7761L39.43 17.9347"
                    stroke="#005C53"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>
              </div>

              <div className="text-center">
                <div className="mt-4 mb-12 mx-auto flex flex-col items-center justify-center">
                  <div className="text-[#060606] text-[16px] font-[600]">
                    <p>Payment Successful</p>
                  </div>
                  <div className="mt-2 text-[#4A4747] text-[14px] font-normal">
                    <p>
                      Thank you! Your payment has been received, and we’re
                      <br />
                      updating your account.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default PaymentSuccessful;
